import initialState from './initialState';
import { types } from '../actions/publicSurveyActions';

export default function publicSurveyVerificationReducer(state = initialState.publicSurveyVerification, action) {
  switch (action.type) {
    case types.VERIFY_SURVEY_SUBMISSION: {
      return { fetching: true };
    }
    case types.VERIFY_SURVEY_SUBMISSION_SUCCESS: {
      return { fetching: false, ok: true };
    }
    case types.VERIFY_SURVEY_SUBMISSION_FAILURE: {
      return { fetching: false, ok: false };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/publicSurveyVerificationReducer.js